import { Pipe, PipeTransform } from '@angular/core';

import { ScheduleEvent } from './../../quickstarts/quickstart-schedule/services/schedule.service';
import { ProgrammingUtilsService, DAYS_OF_THE_WEEK } from '../services/utils.service';
import { WEEKS_OF_THE_MONTH, MONTHS_OF_THE_YEAR } from './../services/utils.service';
import { EventStartTimeLabelPipe } from './event-start-time-label.pipe';

@Pipe({
  name: 'scheduleLabel'
})
export class ScheduleLabelPipe implements PipeTransform {

  private startTimeLabel: EventStartTimeLabelPipe

  constructor(
    private utils: ProgrammingUtilsService
  ) {
    this.startTimeLabel = new EventStartTimeLabelPipe(this.utils);
  }

  transform(schedule: ScheduleEvent, args?: any): any {
    // console.log('schedule-label: ', schedule);
    let display = '';

    if (schedule && schedule.start) {
      // start date
      if (schedule.start.start_date && schedule.start.start_date.start_period) {
        // relative start
        display += 'on the ';
        display += WEEKS_OF_THE_MONTH[schedule.start.start_date.start_period];
        display += ' ';
        display += DAYS_OF_THE_WEEK[schedule.start.start_date.start_weekday];
        display += ' of ';
        display += MONTHS_OF_THE_YEAR[schedule.start.start_date.start_month];
        display += ', ';
        display += schedule.start.start_date.start_year;
        display += ', ';
      } else {
        // fixed start
        display += ' on '
        display += this.utils.toDateDisplay(
          schedule.start.start_date.start_year,
          schedule.start.start_date.start_month,
          schedule.start.start_date.start_day);
        display += ', ';
      }

      // start time
      display += this.startTimeLabel.transform(schedule);

      // repeat
      if (!!schedule.repeat) {
        if (!!schedule.repeat.frequency) {
          display = 'Starting ' + display;
        } else {
          display = 'Happening once ' + display;
        }

        // end date
        if (!!schedule.repeat.end_date) {
          display += ' until ';
          display += this.utils.toDateDisplay(
            schedule.repeat.end_date.end_year,
            schedule.repeat.end_date.end_month,
            schedule.repeat.end_date.end_day);
        }
      }
    }

    // console.log('composed schedule label is ', display);
    return display;
  }

  private getFrequency(repeat: any): string {
    let freq = '';

    switch (repeat.frequency) {
      case 0: break;
      case 1: freq += 'day'; break;
      case 2: freq += 'week'; break;
      case 3: freq = 'month'; break;
      case 4: freq = 'year'; break;
    }

    if (parseInt(repeat.rate) > 0) {
      freq += 's';
    }

    return freq;
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/pipes/schedule-label.pipe.ts